function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #c27315;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 7px;\n      }\n\n      .cls-2 {\n        fill: #ffd9a0;\n        stroke-width: 0px;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 253,
  cy: 253,
  r: 253
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m75.01,239.79c0,.14,0,.28,0,.42,0,98.31,79.69,178,178,178s178-79.69,178-178c0-.14,0-.28,0-.42H75.01Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m117.5,318.79s20-56,55-46"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m159.5,364.79s-2.12-39.99,46.93-46c22.74-2.78,26.08-17.66,26.07-37.11,0-2.18,39.59,3.97,42.28,4.74,17.88,5.1,29.93,16.41,31.59,35.37s-2.66,49.65-18.87,60.99c-15.82,11.08-35.08,2.19-48.01-9.49-1.69-1.52-3.56-3.11-5.84-3.31-7.48-.6-11.72,19.23-7.15,23.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m358.5,359.79s-33.37-93.39,17.81-88.2c0,0,23.19,4.2,28.19-5.8,0,0,15.33-10,24.66,0"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "103.5 142.79 220.77 142.79 243.5 207.79 83.5 207.79 103.5 142.79"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 163.5,
  y1: 239.79,
  x2: 163.5,
  y2: 142.79
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 232.13,
  y1: 175.29,
  x2: 93.5,
  y2: 175.29
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 311.5,
  y1: 87.79,
  x2: 311.5,
  y2: 239.79
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "268.5 158.79 311.5 136.37 354.82 158.79"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "383.5 232.79 383.5 168.09 402.92 142.79"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "354.5 168.79 383.5 168.09 402.92 191.29"
}));

function SvgEnvironmental1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506 506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmental1);
export default __webpack_public_path__ + "static/media/environmental1.8ad29d91.svg";
export { ForwardRef as ReactComponent };